import { signerState } from '../../model/details/signer';
import { LeadDetailRawType } from '../../types/Lead';
import { SignerType } from '../../types/Customer';

export default function transformSignerState(data: LeadDetailRawType) {
    let transform: any[] = [];
    let signerArray: any[] = data.signers;
    signerArray.map((signer) => {
        transform.push(mapSigner(signer));
    });
    return transform;
}

function mapSigner(signer: SignerType) {
    let _transform = {};
    const map = new Map();
    map.set('firstName', 'firstName');
    map.set('lastName', 'lastName');
    map.set('birthdate', 'birthdate');
    map.set('birthplace', 'birthplace');
    map.set('citizenship', 'citizenship');
    map.set('nationality', 'nationality');
    map.set('email', 'email');
    map.set('mobilePhoneNumber', 'mobilePhoneNumber');
    map.set('address.city', 'city');
    map.set('address.country', 'country');
    map.set('address.houseNumber', 'houseNumber');
    map.set('address.postalCode', 'postalCode');
    map.set('address.streetName', 'streetName');
    map.set('address.addressAddition', 'addressAddition');
    map.set('state', 'state');
    map.set('termsAndConditionsConfirmed', 'termsAndConditionsConfirmed');
    map.set('consentGivenAt', 'consentGivenAt');
    map.set('authority', 'authority');

    map.forEach((uiKey, apiKey) => {
        const [type, subKey] = apiKey.split('.');
        let _val;

        // 2. rank : 2 keys like energyInfo.nefzIsEmpty
        if (subKey && signer[type]) {
            _val = signer[type][subKey];
        }
        // 1. rank : standard
        else {
            _val = signer[apiKey] === null ? signerState[uiKey] : signer[apiKey];
        }

        _transform = {
            ..._transform,
            [uiKey]: _val === null ? signerState[uiKey] : _val,
        };
    });

    return _transform;
}
